<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un nivel academico</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los niveles academicos</option>
        <option v-for="NivelAcademico in NivelesAcademicosLocal" :value="NivelAcademico.TipoNivelAcademicoId">{{NivelAcademico.Nombre}}</option>        
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'  
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        NivelesAcademicosLocal:[],
        idDelModelo: null       
      }
    },
    props: {      
      idDelInput: String,
      valorDefinido:Number,
      parametros:Object,
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    mounted(){
       if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
      
      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_SIAP_Catalogo_Establecer007TipoNivelAcademico", parametros);
    },
    created(){      
      this.cargaCatalogDeTiposEstadosCiviles();      
    },
    computed:{
      TipoNivelAcademico(){return this.$store.state.SIAP_Catalogos_025TipoNivelAcademico}
    },
    methods:{      
      cargaCatalogDeTiposEstadosCiviles(){
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba          
        }                                   
        axios.post(api.conexion + api.SIAP.catalogos.C025TiposNivelAcademico,peticion)
        .then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.error(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {                  
              // console.log(respuesta.data.TiposNivelesAcademicos);
              this.NivelesAcademicosLocal = respuesta.data.TiposNivelesAcademicos;
            }
        })
        .catch(excepcion => 
        {
          console.error(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
        })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_SIAP_Catalogo_Establecer007TipoNivelAcademico", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Comun/Catalogos/025TiposNivelAcademico.vue